module.exports = __webpack_public_path__ + "static/hochwertig-910bdc124accd2e432510333e55b5010.png";